import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Service from "../Service/http";
import { toast } from "react-toastify";
import {  ClockLoader, FadeLoader } from "react-spinners";
import Util from "../Service/util";
import { BsInfoCircle, BsQuestionOctagon, BsYoutube } from "react-icons/bs";
import {isValidHandle} from "../Utils/UtilityFunctions"
import { Button } from "react-bootstrap";
import { BsCheckCircle } from 'react-icons/bs';
import {MdHistory} from 'react-icons/md'
import { useQuery } from 'react-query';
import ProfileTabs from './ProfileTabs'

const CodingProfile = () => {
  const all_sites = ['codechef', 'codeforces', 'hackerrank', 'hackerearth', 'interviewbit', 'leetcode', 'mentorpick', 'geeksforgeeks', 'spoj','vjudge'];
  const service = new Service();
  let interval = null;
  const navigate= useNavigate();
  let util = new Util();
  const { id } = useParams();
  const profileSections = [
    { value: 'two', label: 'Coding Profile', path: `/coding/profile/${id}` },
    { value: 'one', label: 'Profile Page', path: `/profile/${id}` },
  ];
  
  let [codingProfile, SetcodingProfile] = useState(null);
  let [prevCodingProfile, SetPrevCodingProfile] = useState(null);
  let [loading, SetLoading] = useState(false);
  let [collegeOptions, SetCollegeOptions] = useState([]);
  let [sitesOptions, SetSitesOptions] = useState([]);
  let [isStudentOrCollege, SetIsStudentOrCollege] = useState(true);
  let [role, SetRole] = useState("student");
  let [tag, setTag] = useState("");
  let [handleUpdateApproved,setHandleUpdateApproved] = useState(true);


  let [departmentOptions, SetdepartmentOptions] = useState([
    { value: "OTH", name: "SELECT" },
    { value: "CSE", name: "CSE" },
    { value: "ECE", name: "ECE" },
    { value: "EEE", name: "EEE" },
    { value: "CSIT", name: "CSIT"},
    { value: "AIDS", name: "AI&DS"},
    { value: "MECHANICAL", name: "MECHANICAL" },
    { value: "IT", name: "IT" },
    { value: "CIVIL", name: "CIVIL" },
    { value: "OTH", name: "OTHER" },
  ]);
  let [tshirtOptions,SettshirtOptions] =useState(
    [
      { value: "OTH", name: "SELECT" },
      { value: "S", name: "S" },
      { value: "M", name: "M" },
      { value: "L", name: "L" },
      { value: "XL", name: "XL" },
      { value: "XXL", name: "XXL" },
    ]
  )



  let filterTags = (tag) => {
    let ftags = codingProfile?.tags?.filter((tagi) => {
      return tag !== tagi;
    });

    let temp = { ...codingProfile };
    temp["tags"] = ftags;
    SetcodingProfile(temp);
  };

  let addTag = () => {
    let temp = { ...codingProfile };
    temp["tags"] = [...codingProfile.tags, tag];
    SetcodingProfile(temp);
    setTag("");
  };
  let handleTagchange = (e) => {
    let tag_name = e.target.value;
    setTag(tag_name);
  };

  
  
  
  useEffect(() => {
    let role = util.getRole();
    if (role == "admin" || role == "mentor" || role == "trainer")
    SetIsStudentOrCollege(false);
  
  service
  .get("api/college/options")
  .then((json) => {
    SetCollegeOptions(json);
  })
  .catch((error) => {
    console.log(error);
  });
  
  service
  .get("api/sites/options")
  .then((json) => {
    SetSitesOptions(json);
    SetRole(util.getRole());
  })
  .catch((error) => {
    console.log(error);
  });
}, []);

useEffect(() => {
    getHandlesOfTheUser();
}, [id]); 

//api call to fetch colleges list from  DB.
  const { data: collegeList, isError: collegeError, refetch: refetchColleges } = useQuery('colleges', () =>
  service.get('api/getColleges').then(response => response)
);

const getHandlesOfTheUser = () => {
  let data
  service
  .get("api/profile/coding/" + id)
  .then((json) => {
    data=json;
    service
    .get("api/handleUpdateApproved")
    .then((json) => {
      data["handleUpdateApproved"] = json.approved;
        SetcodingProfile(data);
        SetPrevCodingProfile(data);
        setHandleUpdateApproved(json.approved);
      })
      .catch((error) => {
        SetcodingProfile(data);
        console.log(error);
      });
      })
      .catch((error) => {
        console.log(error);
      });

  };

  const savecodingProfile = () => {

    let count = localStorage.getItem('triedCount');
    if(interval) clearInterval(interval);

    if(count == null || parseInt(count) >= 5) 
      localStorage.setItem('triedCount', 1);

    let profileChanges = {};
    profileChanges["handleUpdateApproved"] = codingProfile["handleUpdateApproved"];
    for(let field in codingProfile){
      if(codingProfile[field] != prevCodingProfile[field]){
        profileChanges[field] = codingProfile[field];
      }
    }
    

    if(Object.keys(profileChanges).length === 1){
      toast.error("Nothing is changed");
      return;
    }

    SetLoading(true);
    service
      .put("api/profile/coding/" + id, profileChanges)
      .then((json) => {
        toast.success("Updated Success");
        SetLoading(false);
        getHandlesOfTheUser();

        // polling to check the validation status of each handle
        interval = setInterval( () => {
          let count = parseInt(localStorage.getItem('triedCount'))
          getHandlesOfTheUser();
          let polling = false;
          for(let site of all_sites) {
            if(codingProfile[`${site}_validation`] === "PENDING") polling = true;
          }
          // if all handles are validated or count >= 5 -> stop polling
          if(!polling || count >= 5) clearInterval(interval);
          localStorage.setItem('triedCount', count + 1);

        }, 5000);
      })
      .catch((error) => {
        SetLoading(false);
        toast.error("Something went Wrong");
        console.log(error);
      });
  };

  const validateUserHandles = () => {
    // Set loading state to true
    SetLoading(true);

    // Get the userId
    let userId = id;

    // Call the API to validate user handles
    service
      .post("api/profile/validate", { userId })
      .then(async (data) => {
        // Display success message
        toast.success(data.message);

        // Call the function to fetch the user handles
        await getHandlesOfTheUser();

        // Set loading state to false
        SetLoading(false);
      })
      .catch((err) => {
        // Set loading state to false
        SetLoading(false);

        // Display error message
        toast.error("Something went wrong");

        // Log the error
        console.log(err);
      });
  };
  




  return (
    <div className="container">
      <div className="text-center h5 font-monospace text-primary mt-2 mb-2">
      <div style={{ display: "flex", justifyContent: "space-between" }}>
      <ProfileTabs profileSections={profileSections} />

          <div className="d-flex">
         { role==="admin"&&id&&<a
           className="nav-link"
           target="_blank"
           href={`/user/${id}/select_site`}
          >
            <MdHistory size={30}/> User Handle History
          </a>}

          <a
            className="nav-link"
            href={"/faq/1"}
          >
            <BsQuestionOctagon size={30} /> FAQ
          </a>
          </div>
        </div>
        Student Details
       
      </div>

      {!loading ? (
        <div className="row ">


          <div className="mt-3 col-sm-12 col-md-12 col-lg-12 ">
            <form
              onSubmit={(e) => {
                e.preventDefault();
                savecodingProfile();
              }}
            >
              <div className="row">
                <div className=" col-lg-6 col-md-12 col-sm-12">
                  <div className="text-start">
                    <b>
                      Name{" "}
                    </b>{" "}
                  </div>

                  <div className="input-group mb-2">
                    <input
                      className="form-control text-primary font-monospace"
                      value={
                        codingProfile && codingProfile.name
                          ? codingProfile.name
                          : ""
                      }
                      type="text"
                      placeholder="Name"
                      name="name"
                      disabled= {role == "admin"?false:true}
                      onChange={(e) => {
                        let temp = { ...codingProfile };
                        temp["name"] = e.target.value;
                        SetcodingProfile(temp);
                      }}
                    />
                  </div>
                </div>

                {collegeList ? (
                  <div className=" col-lg-6 col-md-12 col-sm-12">
                    <div className="text-start ">
                      <b>
                        Institute{" "}
                        <span className="text-warning"> ( *mandatory ) </span>
                      </b>{" "}
                    </div>
                    <div className="input-group mb-2">
                      <label
                        className="p-1 input-group-text text-primary ps-2"
                        id="basic-addon1"
                      >
                        COLLEGE NAME
                      </label>

                      <select
                        className="form-select text-primary"
                        value={
                          codingProfile && codingProfile.college
                            ? codingProfile.college
                            : ""
                        }
                        name="college"
                        onChange={(e) => {
                          let temp = { ...codingProfile };
                          temp["college"] = e.target.value;
                          SetcodingProfile(temp);
                        }}
                        id="collegeSelect"
                      >
                        <option value="null">SELECT COLLEGE</option>
                        {collegeList && collegeList?.data?.map((ele, ind) => {
                          return (
                            <option key={ind} value={ele?.value}>
                              {ele?.college_name}{" "}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                ) : null}


                <div className=" col-lg-6 col-md-12 col-sm-12">
                  <div className="text-start">
                    <b>
                      College Registration Number{" "}
                      <span className="text-warning"> ( *mandatory ) </span>
                    </b>{" "}
                  </div>

                  <div className="input-group mb-2">
                    <input
                      className="form-control text-primary font-monospace"
                      value={
                        codingProfile && codingProfile.roll_number
                          ? codingProfile.roll_number
                          : ""
                      }
                      type="text"
                      placeholder="Enter Roll Number"
                      name="roll_number"
                      onChange={(e) => {
                        let temp = { ...codingProfile };
                        temp["roll_number"] = e.target.value;
                        SetcodingProfile(temp);
                      }}
                    />
                  </div>
                </div>

                <div className=" col-lg-6 col-md-12 col-sm-12">
                  <div className="text-start ">
                    <b>
                      Department{" "}
                      <span className="text-warning"> ( *mandatory ) </span>
                    </b>{" "}
                  </div>
                  <div className="input-group mb-2">
                    <label
                      className="p-1 input-group-text text-primary ps-2"
                      id="basic-addon1"
                    >
                      SELECT YOUR DEPARTMENT
                    </label>

                    <select
                      className="form-select text-primary"
                      value={
                        codingProfile && codingProfile.department
                          ? codingProfile.department
                          : ""
                      }
                      name="batch"
                      onChange={(e) => {
                        let temp = { ...codingProfile };
                        temp["department"] = e.target.value;
                        SetcodingProfile(temp);
                      }}
                      id="departmentSelect"
                    >
                      {" "}
                      {departmentOptions.map((ele, ind) => {
                        return (
                          <option key={ind} value={ele?.value}>
                            {" "}
                            {ele?.name}{" "}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>

                <div className=" col-lg-6 col-md-12 col-sm-12">
                  <div className="text-start">
                    <b>
                    Company Placed Or Working On{" "}
                    </b>{" "}
                  </div>

                  <div className="input-group mb-2">
                    <input
                      className="form-control text-primary font-monospace"
                      value={
                        codingProfile && codingProfile.companies_placed_in
                          ? codingProfile.companies_placed_in
                          : ""
                      }
                      type="text"
                      placeholder="Enter Company Placed Or Working On"
                      name="Company Placed Or Working On"
                      onChange={(e) => {
                        let temp = { ...codingProfile };
                        temp["companies_placed_in"] = e.target.value;
                        SetcodingProfile(temp);
                      }}
                    />
                  </div>
                </div>




                <div className=" col-lg-6 col-md-12 col-sm-12">
                  <div className="text-start">
                    <b>College CGPA/Percentage</b>{" "}
                  </div>

                  <div className="input-group mb-2">
                    <span className="p-1 input-group-text text-primary ps-2">
                      College CGPA/Percentage
                    </span>
                    <input
                      className="form-control text-primary font-monospace"
                      value={
                        codingProfile && codingProfile.college_cgpa
                          ? codingProfile.college_cgpa
                          : ""
                      }
                      type="text"
                      placeholder="Enter Your Current CGPA/Percentage"
                      name="college_cgpa"
                      onChange={(e) => {
                        let temp = { ...codingProfile };
                        temp["college_cgpa"] = e.target.value;
                        SetcodingProfile(temp);
                      }}
                    />
                  </div>
                </div>

                <div className=" col-lg-6 col-md-12 col-sm-12">
                  <div className="text-start">
                    <b>No Of Active Backlogs</b>{" "}
                  </div>

                  <div className="input-group mb-2">
                    <span className="p-1 input-group-text text-primary ps-2">
                      Enter No Of Active Backlogs
                    </span>
                    <input
                      className="form-control text-primary font-monospace"
                      value={
                        codingProfile && codingProfile.backlogs
                          ? codingProfile.backlogs
                          : ""
                      }
                      type="text"
                      placeholder="Enter Your Current Backlogs"
                      name="backlogs"
                      onChange={(e) => {
                        let temp = { ...codingProfile };
                        temp["backlogs"] = e.target.value;
                        SetcodingProfile(temp);
                      }}
                    />
                  </div>
                </div>
                <div className=" col-lg-6 col-md-12 col-sm-12">
                  <div className="text-start">
                    <b>Linkdin</b>{" "}
                  </div>

                  <div className="input-group mb-2">
                    <span className="p-1 input-group-text text-primary ps-2">
                      https://www.linkedin.com/in/
                    </span>
                    <input
                      className="form-control text-primary font-monospace"
                      value={
                        codingProfile && codingProfile.linkden_username
                          ? codingProfile.linkden_username
                          : ""
                      }
                      type="text"
                      placeholder="Enter linkedin username"
                      name="linkden_username"
                      onChange={(e) => {
                        let temp = { ...codingProfile };
                        temp["linkden_username"] = e.target.value;
                        SetcodingProfile(temp);
                      }}
                    />
                  </div>
                </div>

                <div className=" col-lg-6 col-md-12 col-sm-12">
                  <div className="text-start">
                    <b>Github</b>{" "}
                  </div>

                  <div className="input-group mb-2">
                    <span className="p-1 input-group-text text-primary ps-2">
                      https://github.com/
                    </span>
                    <input
                      className="form-control text-primary font-monospace"
                      value={
                        codingProfile && codingProfile.github_username
                          ? codingProfile.github_username
                          : ""
                      }
                      type="text"
                      placeholder="Enter github username"
                      name="github_username"
                      onChange={(e) => {
                        let temp = { ...codingProfile };
                        temp["github_username"] = e.target.value;
                        SetcodingProfile(temp);
                      }}
                    />
                  </div>
                </div>

                <div className=" col-lg-6 col-md-12 col-sm-12">
                  <div className="text-start">
                    <b>Deployment</b>{" "}
                  </div>
                  <div className="input-group mb-2">
                    <span className="p-1 input-group-text text-primary ps-2">
                      Enter link of your deployment
                    </span>
                    <input
                      className="form-control text-primary font-monospace"
                      value={
                        codingProfile && codingProfile.deployed_application_link
                          ? codingProfile.deployed_application_link
                          : ""
                      }
                      type="text"
                      placeholder="Enter link to your project"
                      name="deployed_application_link"
                      onChange={(e) => {
                        let temp = { ...codingProfile };
                        temp["deployed_application_link"] = e.target.value;
                        SetcodingProfile(temp);
                      }}
                    />
                  </div>
                </div>
                <div className=" col-lg-6 col-md-12 col-sm-12">
                  <div className="text-start">
                    <b>Phone Number (+91)</b>{" "}
                  </div>
                  <div className="input-group mb-2">
                    <span className="p-1 input-group-text text-primary ps-2">
                      Enter Your Phone Number
                    </span>
                    <input
                      className="form-control text-primary font-monospace"
                      value={
                        codingProfile && codingProfile.phoneNumber
                          ? codingProfile.phoneNumber
                          : ""
                      }
                      type="text"
                      placeholder="Enter Your Phone Number"
                      name="PhoneNumber"
                      onChange={(e) => {
                        let temp = { ...codingProfile };
                        temp["phoneNumber"] = e.target.value;
                        SetcodingProfile(temp);
                      }}
                    />
                  </div>
                </div>



                {collegeOptions.length > 0 ? (
                  <div className=" col-lg-6 col-md-12 col-sm-12">
                    <div className="text-start ">
                      <b>
                        T-Shirt Size{" "}
                      </b>{" "}
                    </div>
                    <div className="input-group mb-2">
                      <label
                        className="p-1 input-group-text text-primary ps-2"
                        id="basic-addon1"
                      >
                        Select Your T-Shirt Size
                      </label>

                      <select
                        className="form-select text-primary"
                        value={
                          codingProfile && codingProfile.tshirt_size
                            ? codingProfile.tshirt_size
                            : ""
                        }
                        name="tshirt_size"
                        onChange={(e) => {
                          let temp = { ...codingProfile };
                          temp["tshirt_size"] = e.target.value;
                          SetcodingProfile(temp);
                        }}
                        id="tshirtSizeSelect"
                      >
                        {" "}
                        {tshirtOptions.map((ele, ind) => {
                          return (
                            <option key={ind} value={ele?.value}>
                              {" "}
                              {ele?.name}{" "}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                ) : null}


              </div>

              <div className="text-center m-2">
                <b>Badges Associated</b>{" "}
              </div>
              <div className="d-flex justify-content-center">
                {codingProfile?.tags?.map((tag, ind) => {
                  return (
                    <div key={ind}>
                      <span className="badge bg-primary m-2">
                        {tag}{" "}
                        {role !== "student" ? (
                          <button type="button" onClick={() => filterTags(tag)}>
                            X
                          </button>
                        ) : null}{" "}
                      </span>
                    </div>
                  );
                })}
              </div>
              <div className=" col-lg-6 col-md-12 col-sm-12 mx-auto">
                {role == "admin" || role == "mentor" || role == "trainer" ? (
                  <div className="input-group mb-2">
                    <span className="p-1 input-group-text text-primary ps-2">
                      Enter Tags For This User
                    </span>
                    <input
                      className="form-control text-primary font-monospace"
                      // value={
                      //     codingProfile &&
                      //     codingProfile.tags
                      //         ? codingProfile.tags
                      //         : ""
                      // }
                      value={tag}
                      type="text"
                      placeholder="Enter Tags Here"
                      name="tag"
                      onChange={handleTagchange}
                      // onChange={(e) => {
                      //     let temp = { ...codingProfile };
                      //     temp["tags"] =
                      //         e.target.value;
                      //     SetcodingProfile(temp);
                      // }}
                    />
                    <button
                      onClick={addTag}
                      type="button"
                      className="btn btn-primary"
                    >
                      Add Tag
                    </button>
                  </div>
                ) : null}
              </div>

              <hr/>


              <div className="text-center text-primary mb-3">Coding Profiles</div>
              <div className="text-center mb-4">
                  <BsInfoCircle style={{ marginRight: '10px'}} color="black" /> 
                  <span style={{ color: 'gray'}}>
                    Enter only the username from the URL (e.g., if the URL is
                    <span className="text-dark"> https://example.com/user/</span>
                    <span className="text-dark" style={{ fontWeight: 'bold'}}>ExampleUserName</span>, 
                    only fill '<span className="text-dark">ExampleUserName</span>').
                  </span>
              </div>
              {/* <br/> */}
              
              <div className="row">

              {sitesOptions.includes("CODECHEF") ? (
                <div className=" col-lg-6 col-md-12 col-sm-12">
                  <div className="text-start">
                    <b>
                      Codechef Handle (
                      <span className="text-warning"> *mandatory </span>
                      <a
                        target="_blank"
                        href="https://www.youtube.com/watch?v=8409u46PF2w"
                      >
                        {" "}
                        <BsYoutube/> Refer Instructions{" "}
                      </a>
                      ){" "}
                      {codingProfile && (!codingProfile.codechef_validation || codingProfile.codechef_validation === 'DONE') && (codingProfile?.codechef_valid === false||!isValidHandle(codingProfile?.codechef)) ? (
                        <span className="text-danger"><span style={{ fontSize: '1.4em' }}>👈</span> Invalid Username </span>
                      ) : null}
                    </b>{" "}
                  </div>

                  <div className="input-group mb-2">
                    {

                      codingProfile && codingProfile.codechef?(
                        <a className="p-1 input-group-text text-primary ps-2" href={`https://www.codechef.com/users/${codingProfile.codechef}`} target='_blank'>
                          <span >
                            https://www.codechef.com/users/
                          </span>
                        </a>
                      )
                      :
                      (
                      <span className="p-1 input-group-text text-primary ps-2">
                        https://www.codechef.com/users/
                      </span>
                      )

                    }
                    <input
                      disabled = {! handleUpdateApproved}
                      className="form-control text-primary font-monospace"
                      value={
                        codingProfile && codingProfile.codechef
                          ? codingProfile.codechef
                          : ""

                      }
                      type="text"
                      placeholder="Enter codechef username"
                      name="codechef"
                      onChange={(e) => {
                        let temp = { ...codingProfile };
                        temp["codechef"] = e.target.value;
                        SetcodingProfile(temp);
                        // Validation(e.target.value,"codechef");
                      }}
                    />
                    {

                    // <TickIcon userName={codingProfile && codingProfile.codechef
                        // validUserNames["codechef"] !== null && validUserNames.codechef?(
                      // <TickIcon isValid={validUserNames.codechef} />

                      <VerifyAndTick userName={codingProfile && codingProfile.codechef && isValidHandle(codingProfile.codechef)
                        ? codingProfile.codechef
                        : ""
                      } isValid={codingProfile?codingProfile.codechef_valid:false} verifyStatus={codingProfile && (!codingProfile.codechef_validation || codingProfile.codechef_validation === 'DONE')} platform ={`codechef`} />


                    }
                  </div>

                </div>
              ) : null}
              {sitesOptions.includes("CODEFORCES") ? (
                <div className="col-lg-6 col-md-12 col-sm-12">
                  <div className="text-start">
                    <b>
                      Codeforces Handle (
                      <span className="text-warning"> *mandatory </span>
                      <a
                        target="_blank"
                        href="https://www.youtube.com/watch?v=SuYI49nkxVg"
                      >
                        {" "}
                        <BsYoutube/> Refer Instructions{" "}
                      </a>
                      ){" "}
                      {codingProfile && (!codingProfile.codeforces_validation || codingProfile.codeforces_validation === 'DONE') && (codingProfile?.codeforces_valid == false ||!isValidHandle(codingProfile?.codeforces))? (
                        <span className="text-danger"> <span style={{ fontSize: '1.4em' }}>👈</span> Invalid Username </span>
                      ) : null}
                    </b>
                  </div>

                  <div className="mb-2 input-group mb-2">
                    {

                      codingProfile && codingProfile.codeforces?(
                        <a className="p-1 input-group-text text-primary ps-2" href={`https://codeforces.com/profile/${codingProfile.codeforces}`} target='_blank'>
                          <span >
                            https://codeforces.com/profile/
                          </span>
                        </a>
                      )
                      :
                      (
                      <span className="p-1 input-group-text text-primary ps-2">

                        https://codeforces.com/profile/
                      </span>
                      )

                    }
                    <input
                      disabled = {! handleUpdateApproved}
                      className="form-control text-primary font-monospace"
                      value={
                        codingProfile && codingProfile.codeforces
                          ? codingProfile.codeforces
                          : ""
                      }
                      type="text"
                      placeholder="Enter codeforces username"
                      name="codeforces"
                      onChange={(e) => {
                        let temp = { ...codingProfile };
                        temp["codeforces"] = e.target.value;
                        SetcodingProfile(temp);
                      }}
                    />
                    <VerifyAndTick userName={codingProfile && codingProfile.codeforces && isValidHandle(codingProfile?.codeforces)
                        ? codingProfile.codeforces
                        : ""
                      } isValid={codingProfile?codingProfile.codeforces_valid:false} verifyStatus={codingProfile && (!codingProfile.codeforces_validation || codingProfile.codeforces_validation === 'DONE')} platform ={`codeforces`} />
                  </div>
                </div>
              ) : null}
              {sitesOptions.includes("GEEKSFORGEEKS") ? (
                <div className="col-lg-6 col-md-12 col-sm-12">
                  <div className="text-start">
                    <b>
                      GeeksForGeeks Handle (
                      <span className="text-warning"> *mandatory </span>
                      <a
                        target="_blank"
                        href="https://www.youtube.com/watch?v=bOiJDZKK6_M"
                      >
                        {" "}
                        <BsYoutube/> Refer Instructions{" "}
                      </a>
                      ){" "}
                      {codingProfile && (!codingProfile.geeksforgeeks_validation || codingProfile.geeksforgeeks_validation === 'DONE') && (codingProfile?.geeksforgeeks_valid == false ||!isValidHandle(codingProfile?.geeksforgeeks))? (
                        <span className="text-danger"> <span style={{ fontSize: '1.4em' }}>👈</span> Invalid Username </span>
                      ) : null}
                    </b>
                  </div>

                  <div className=" input-group mb-2">
                    {

                      codingProfile && codingProfile.geeksforgeeks?(
                        <a className="p-1 input-group-text text-primary ps-2" href={`https://auth.geeksforgeeks.org/user/${codingProfile.geeksforgeeks}`} target='_blank'>
                          <span >
                            https://auth.geeksforgeeks.org/user/
                          </span>
                        </a>
                      )
                      :
                      (
                      <span className="p-1 input-group-text text-primary ps-2">

                        https://auth.geeksforgeeks.org/user/
                      </span>
                      )

                    }

                    <input
                      disabled = {! handleUpdateApproved}
                      className="form-control text-primary font-monospace"
                      value={
                        codingProfile && codingProfile.geeksforgeeks
                          ? codingProfile.geeksforgeeks
                          : ""
                      }
                      type="text"
                      placeholder="Enter geeksforgeeks username"
                      name="geeksforgeeks"
                      onChange={(e) => {
                        let temp = { ...codingProfile };
                        temp["geeksforgeeks"] = e.target.value;
                        SetcodingProfile(temp);
                      }}
                    />
                    <VerifyAndTick userName={codingProfile && codingProfile.geeksforgeeks&&isValidHandle(codingProfile?.geeksforgeeks)
                        ? codingProfile.geeksforgeeks
                        : ""
                      } isValid={codingProfile?codingProfile.geeksforgeeks_valid:false}  platform ={`geeksforgeeks`} />
                    <label
                      className="p-1 input-group-text text-primary"
                      id="basic-addon1"
                    >
                      /profile
                    </label>
                  </div>
                </div>
              ) : null}
              {sitesOptions.includes("HACKEREARTH") ? (
                <div className="col-lg-6 col-md-12 col-sm-12">
                  <div className="text-start">
                    <b>
                      HackerEarth Handle (
                      <span className="text-warning"> *mandatory </span>
                      <a
                        target="_blank"
                        href="https://www.youtube.com/watch?v=ObSVpPY4jOs"
                      >
                        {" "}
                        <BsYoutube/> Refer Instructions{" "}
                      </a>
                      ){" "}
                    </b>
                    {codingProfile && (!codingProfile.hackerearth_validation || codingProfile.hackerearth_validation === 'DONE') && (codingProfile?.hackerearth_valid == false ||!isValidHandle(codingProfile?.hackerearth)) ? (
                        <span className="text-danger"><span style={{ fontSize: '1.4em' }}>👈</span>Invalid Username </span>
                      ) : null}
                  </div>

                  <div className=" input-group mb-2">
                    {

                      codingProfile && codingProfile.hackerearth?(
                        <a className="p-1 input-group-text text-primary ps-2" href={`https://www.hackerearth.com/@${codingProfile.hackerearth}`} target='_blank'>
                          <span >
                            https://www.hackerearth.com/@
                          </span>
                        </a>
                      )
                      :
                      (
                      <span className="p-1 input-group-text text-primary ps-2">

                        https://www.hackerearth.com/@
                      </span>
                      )

                    }

                    <input
                      disabled = {! handleUpdateApproved}
                      className="form-control text-primary font-monospace"
                      value={
                        codingProfile && codingProfile.hackerearth
                          ? codingProfile.hackerearth
                          : ""
                      }
                      type="text"
                      placeholder="Enter hackerearth username"
                      name="hackerearth"
                      onChange={(e) => {
                        let temp = { ...codingProfile };
                        temp["hackerearth"] = e.target.value;
                        SetcodingProfile(temp);
                      }}
                    />
                  </div>
                </div>
              ) : null}
              {sitesOptions.includes("HACKERRANK") ? (
                <div className="col-lg-6 col-md-12 col-sm-12">
                  <div className="text-start">
                    <b>
                      HackerRank Handle (
                      <span className="text-warning"> *mandatory </span>
                      <a
                        target="_blank"
                        href="https://www.youtube.com/watch?v=KPWXnaBzggM"
                        style={{}}
                      >
                        {" "}
                        
                        <BsYoutube/> Refer Instructions{" "}
                      </a>
                      ){" "}
                      {codingProfile && (!codingProfile.hackerrank_validation || codingProfile.hackerrank_validation === 'DONE') && (codingProfile?.hackerrank_valid == false ||!isValidHandle(codingProfile?.hackerrank))? (
                        <span className="text-danger"> <span style={{ fontSize: '1.4em' }}>👈</span> Invalid Username </span>
                      ) : null}
                    </b>{" "}
                  </div>

                  <div className="input-group mb-2">
                    {

                      codingProfile && codingProfile.hackerrank?(
                        <a className="p-1 input-group-text text-primary ps-2" href={`https://www.hackerrank.com/${codingProfile.hackerrank}`} target='_blank'>
                          <span >
                          https://www.hackerrank.com/{" "}
                          </span>
                        </a>
                      )
                      :
                      (
                      <span className="p-1 input-group-text text-primary ps-2">

                        https://www.hackerrank.com/{" "}
                      </span>
                      )

                    }




                    <input
                      disabled = {! handleUpdateApproved}
                      className="form-control text-primary font-monospace"
                      value={
                        codingProfile && codingProfile.hackerrank
                          ? codingProfile.hackerrank
                          : ""
                      }
                      type="text"
                      placeholder="Enter hackerrank username"
                      name="hackerrank"
                      onChange={(e) => {
                        let temp = { ...codingProfile };
                        temp["hackerrank"] = e.target.value;
                        SetcodingProfile(temp);
                      }}


                    />

                    <VerifyAndTick userName={codingProfile && codingProfile.hackerrank && isValidHandle(codingProfile?.hackerrank)
                        ? codingProfile.hackerrank
                        : ""
                      } isValid={codingProfile?codingProfile.hackerrank_valid:false} verifyStatus={codingProfile && (!codingProfile.hackerrank_validation || codingProfile.hackerrank_validation === 'DONE')} platform ={`hackerrank`} />
                  </div>
                </div>
              ) : null}
              {sitesOptions.includes("LEETCODE") ? (
                <div className="col-lg-6 col-md-12 col-sm-12">
                  <div className="text-start">
                    <b>
                      LeetCode Handle (
                      <span className="text-warning"> *mandatory </span>
                      <a
                        target="_blank"
                        href="https://www.youtube.com/watch?v=YfRl1bvNk34"
                      >
                        {" "}
                        <BsYoutube/> Refer Instructions{" "}
                      </a>
                      ){" "}
                      {codingProfile && (!codingProfile.leetcode_validation || codingProfile.leetcode_validation === 'DONE') && (codingProfile?.leetcode_valid == false ||!isValidHandle(codingProfile?.leetcode))? (
                        <span className="text-danger"><span style={{ fontSize: '1.4em' }}>👈</span> Invalid Username </span>
                      ) : null}
                    </b>
                  </div>

                  <div className="mb-2 input-group">
                    {

                      codingProfile && codingProfile.leetcode?(
                        <a className="p-1 input-group-text text-primary ps-2" href={`https://leetcode.com/${codingProfile.leetcode}`} target='_blank'>
                          <span >
                          https://leetcode.com/
                          </span>
                        </a>
                      )
                      :
                      (
                      <span className="p-1 input-group-text text-primary ps-2">

                        https://leetcode.com/
                      </span>
                      )

                    }

                    <input
                      disabled = {! handleUpdateApproved}
                      className="form-control text-primary font-monospace"
                      value={
                        codingProfile && codingProfile.leetcode
                          ? codingProfile.leetcode
                          : ""
                      }
                      type="text"
                      placeholder="Enter leetcode username"
                      name="leetcode"
                      onChange={(e) => {
                        let temp = { ...codingProfile };
                        temp["leetcode"] = e.target.value;
                        SetcodingProfile(temp);
                      }}
                    />
                    <VerifyAndTick userName={codingProfile && codingProfile.leetcode&&isValidHandle(codingProfile?.leetcode)
                        ? codingProfile.leetcode
                        : ""
                      } isValid={codingProfile?codingProfile.leetcode_valid:false} verifyStatus={codingProfile && (!codingProfile.leetcode_validation || codingProfile.leetcode_validation === 'DONE')} platform ={`leetcode`} />
                  </div>
                </div>
              ) : null}
              {sitesOptions.includes("INTERVIEWBIT") ? (
                <div className="col-lg-6 col-md-12 col-sm-12">
                  <div className="text-start">
                    <b>
                      InterviewBit Handle (
                      <span className="text-warning"> *mandatory </span>
                      <a
                        target="_blank"
                        href="https://www.youtube.com/watch?v=bOiJDZKK6_M"
                      >
                        {" "}
                        <BsYoutube/> Refer Instructions{" "}
                      </a>
                      ){" "}
                      {codingProfile && (!codingProfile.interviewbit_validation || codingProfile.interviewbit_validation === 'DONE') && (codingProfile?.interviewbit_valid == false ||!isValidHandle(codingProfile?.interviewbit)) ? (
                        <span className="text-danger"> <span style={{ fontSize: '1.4em' }}>👈</span> Invalid Username </span>
                      ) : null}
                    </b>
                  </div>

                  <div className="mb-2 input-group ">
                    {

                      codingProfile && codingProfile.interviewbit?(
                        <a className="p-1 input-group-text text-primary ps-2" href={`https://www.interviewbit.com/profile/${codingProfile.interviewbit}`} target='_blank'>
                          <span >
                            https://www.interviewbit.com/profile/
                          </span>
                        </a>
                      )
                      :
                      (
                      <span className="p-1 input-group-text text-primary ps-2">

                        https://www.interviewbit.com/profile/
                      </span>
                      )

                    }

                    <input
                      disabled = {! handleUpdateApproved}
                      className="form-control text-primary font-monospace"
                      value={
                        codingProfile && codingProfile.interviewbit
                          ? codingProfile.interviewbit
                          : ""
                      }
                      type="text"
                      placeholder="Enter interviewbit username"
                      name="interviewbit"
                      onChange={(e) => {
                        let temp = { ...codingProfile };
                        temp["interviewbit"] = e.target.value;
                        SetcodingProfile(temp);
                      }}
                    />
                    <VerifyAndTick userName={codingProfile && codingProfile.interviewbit&&isValidHandle(codingProfile?.interviewbit)
                        ? codingProfile.interviewbit
                        : ""
                      } isValid={codingProfile?codingProfile.interviewbit_valid:false} verifyStatus={codingProfile && (!codingProfile.interviewbit_validation || codingProfile.interviewbit_validation === 'DONE')} platform ={`interviewbit`} />
                  </div>
                </div>
              ) : null}
              {sitesOptions.includes("SPOJ") ? (
                <div className="col-lg-6 col-md-12 col-sm-12">
                  <div className="text-start">
                    <b>
                      SPOJ Handle (
                      <span className="text-warning"> *mandatory </span>
                      <a
                        target="_blank"
                        href="https://www.youtube.com/watch?v=H1DdbthW5AY"
                      >
                        {" "}
                        <BsYoutube/> Refer Instructions{" "}
                      </a>
                      ){" "}
                      {codingProfile && (!codingProfile.spoj_validation || codingProfile.spoj_validation === 'DONE') && (codingProfile?.spoj_valid == false ||!isValidHandle(codingProfile?.spoj)) ? (
                        <span className="text-danger"><span style={{ fontSize: '1.4em' }}>👈</span> Invalid Username </span>
                      ) : null}
                    </b>
                  </div>

                  <div className="input-group mb-2">
                    {

                      codingProfile && codingProfile.spoj?(
                        <a className="p-1 input-group-text text-primary ps-2" href={`https://www.spoj.com/users/${codingProfile.spoj}`} target='_blank'>
                          <span >
                            https://www.spoj.com/users/
                          </span>
                        </a>
                      )
                      :
                      (
                      <span className="p-1 input-group-text text-primary ps-2">

                        https://www.spoj.com/users/
                      </span>
                      )

                    }

                    <input
                      disabled = {! handleUpdateApproved}
                      className="form-control text-primary font-monospace "
                      value={
                        codingProfile && codingProfile.spoj
                          ? codingProfile.spoj
                          : ""
                      }
                      type="text"
                      placeholder="Enter spoj username"
                      name="spoj"
                      onChange={(e) => {
                        let temp = { ...codingProfile };
                        temp["spoj"] = e.target.value;
                        SetcodingProfile(temp);
                      }}
                    />

                    <VerifyAndTick userName={codingProfile && codingProfile.spoj&&isValidHandle(codingProfile?.spoj)
                        ? codingProfile.spoj
                        : ""
                      } isValid={codingProfile?codingProfile.spoj_valid:false} verifyStatus={codingProfile && (!codingProfile.spoj_validation || codingProfile.spoj_validation === 'DONE')} platform ={`spoj`} />
                  </div>
                </div>
              ) : null}
              {sitesOptions.includes("VJUDGE") ? (
                <div className="col-lg-6 col-md-12 col-sm-12">
                  <div className="text-start">
                    <b>
                      Vjudge Handle (
                      <span className="text-warning"> *mandatory </span>
                      <a
                        target="_blank"
                        href="https://www.youtube.com/watch?v=GIsbR-efbPg"
                      >
                        {" "}
                        <BsYoutube/> Refer Instructions{" "}
                      </a>
                      ){" "}
                      {codingProfile && (!codingProfile.vjudge_validation || codingProfile.vjudge_validation === 'DONE') && (codingProfile?.vjudge_valid == false ||!isValidHandle(codingProfile?.vjudge)) ? (
                        <span className="text-danger"><span style={{ fontSize: '1.4em' }}>👈</span> Invalid Username </span>
                      ) : null}
                    </b>{" "}
                  </div>

                  <div className=" input-group mb-2">
                    {

                      codingProfile && codingProfile.vjudge?(
                        <a className="p-1 input-group-text text-primary ps-2" href={`https://vjudge.net/user/${codingProfile.vjudge}`} target='_blank'>
                          <span >
                            https://vjudge.net/user/
                          </span>
                        </a>
                      )
                      :
                      (
                      <span className="p-1 input-group-text text-primary ps-2">

                        https://vjudge.net/user/
                      </span>
                      )

                    }

                    <input
                      disabled = {! handleUpdateApproved}
                      className="form-control text-primary font-monospace"
                      value={
                        codingProfile && codingProfile.vjudge
                          ? codingProfile.vjudge
                          : ""
                      }
                      type="text"
                      placeholder="Enter vjudge username"
                      name="vjudge"
                      onChange={(e) => {
                        let temp = { ...codingProfile };
                        temp["vjudge"] = e.target.value;
                        SetcodingProfile(temp);
                      }}
                    />
                    <VerifyAndTick userName={codingProfile && codingProfile.vjudge&&isValidHandle(codingProfile?.vjudge)
                        ? codingProfile.vjudge
                        : ""
                      } isValid={codingProfile?codingProfile.vjudge_valid:false} verifyStatus={codingProfile && (!codingProfile.vjudge_validation || codingProfile.vjudge_validation === 'DONE')} platform ={`vjudge`} />
                  </div>
                </div>
              ) : null}
              {sitesOptions.includes("UVA") ? (
                <div className="col-lg-6 col-md-12 col-sm-12">
                  <div className="text-start">
                    <b>
                      Uva Online Judge Handle
                      <span className="text-warning">( *mandatory) </span>
                    </b>{" "}
                  </div>

                  <div className="input-group mb-3">

                    <label
                      className="p-1 input-group-text text-primary ps-2"
                      id="basic-addon1"
                    >
                      {" "}
                      Online Judge
                    </label>
                    <input
                      disabled = {! handleUpdateApproved}
                      className="form-control text-primary font-monospace"
                      value={
                        codingProfile && codingProfile.uva
                          ? codingProfile.uva
                          : ""
                      }
                      type="text"
                      placeholder="Enter uva username"
                      name="uva"
                      onChange={(e) => {
                        let temp = { ...codingProfile };
                        temp["uva"] = e.target.value;
                        SetcodingProfile(temp);
                      }}
                    />
                  </div>
                </div>
              ) : null}

{sitesOptions.includes("MENTORPICK") ? (
<div className="col-lg-6 col-md-12 col-sm-12">
                  <div className="text-start">
                    <b>
                      MentorPick Handle (
                      <span className="text-warning"> *mandatory </span>
                      ){" "}
                      {codingProfile && (!codingProfile.mentorpick_validation || codingProfile.mentorpick_validation === 'DONE') && (codingProfile?.mentorpick_valid === false ||!isValidHandle(codingProfile?.mentorpick)) ? (
                        <span className="text-danger"><span style={{ fontSize: '1.4em' }}>👈</span>Invalid Username </span>
                      ) : null}
                    </b>
                  </div>

                  <div className="input-group mb-2">
                  {
                      codingProfile && codingProfile.mentorpick ? (
                        <a className="p-1 input-group-text text-primary ps-2" href={`https://mentorpick.com/profile/${codingProfile?.mentorpick}`} target='_blank'>
                          <span >
                            https://mentorpick.com/profile/
                          </span>
                        </a>
                      )
                      :
                      (
                      <span className="p-1 input-group-text text-primary ps-2">
                        https://mentorpick.com/profile/
                      </span>
                      )
                    }
                    <input
                      value={
                        codingProfile && codingProfile.mentorpick
                          ? codingProfile.mentorpick
                          : ""
                      }
                      className="form-control text-primary font-monospace "
                      type="text"
                      placeholder="Enter mentorpick username"
                      name="mentorpick"
                      disabled = {! handleUpdateApproved}
                      onChange={(e) => {
                        let temp = { ...codingProfile };
                        temp["mentorpick"] = e.target.value;
                        SetcodingProfile(temp);
                      }}
                    />
                     <VerifyAndTick userName={codingProfile && codingProfile.mentorpick&&isValidHandle(codingProfile?.mentorpick)
                        ? codingProfile.mentorpick
                        : ""
                      } isValid={codingProfile?codingProfile.mentorpick_valid:false} verifyStatus={codingProfile && (!codingProfile.mentorpick_validation || codingProfile.mentorpick_validation === 'DONE')} platform ={`mentorpick`} />
                  </div>
                </div>
 ) : null}

                <div className="d-flex justify-content-end mb-5 me-5">
                  <Button type="submit" className="btn btn-primary me-2" variant="primary">
                    Update
                  </Button>
                  {role==="admin"&&<Button onClick={()=>validateUserHandles()}  className="btn btn-primary" variant="primary" size={20}>
                    <BsCheckCircle className="me-2" />
                    Validate Handles
                  </Button>}
                </div>
              </div>
            </form>
          </div>



        </div>
      ) : (
        <div className="text-center mt-5">
          <FadeLoader color="green" />
        </div>
      )}
    </div>
  );
};

const PendingLoader = () => {
  return (
    <div className="d-flex ps-2 justify-content-center align-items-center"><ClockLoader size={25} color="gray"/></div> 
  )
}



const TickIcon = ({isValid})=>{
  // const count = useRef(0);

  // useEffect(() => {
  //   count.current = count.current + 1;
  // });

  // console.log()
  return(
  <>
    {
    isValid?(
    <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-check" width={33} height={33} viewBox="0 0 24 24" strokeWidth="1.5" stroke="#00b341" fill="none" strokeLinecap="round" strokeLinejoin="round">
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M5 12l5 5l10 -10" />
      </svg>):(<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-x" width="33" height="33" viewBox="0 0 24 24" stroke-width="1.5" stroke="#ff2825" fill="none" stroke-linecap="round" stroke-linejoin="round">
      <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>)
    }
  </>
  )
}



const VerifyAndTick = ({userName,isValid, verifyStatus, platform})=>{
  if(userName === '' || isValid==undefined){
    return <></>
  }

  return <>
    {
      isValid && verifyStatus ? (

          <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-check" width={33} height={33} viewBox="0 0 24 24" strokeWidth="1.5" stroke="#00b341" fill="none" strokeLinecap="round" strokeLinejoin="round">
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M5 12l5 5l10 -10" />
        </svg>

      ): verifyStatus ? (<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-x" width="33" height="33" viewBox="0 0 24 24" stroke-width="1.5" stroke="#ff2825" fill="none" stroke-linecap="round" stroke-linejoin="round">
      <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>) : <PendingLoader/>
    }
  </>

}
export default CodingProfile;